import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { adviserSave, officeAllList, adviserAllList } from '../../../../store/actions/memberActions'
import { Switch, Select, Upload, Tooltip, message, Collapse, InputNumber } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { listAllEvents } from '../../../../store/actions/achievementActions'

import { provinceList, citybyprovinceList, officeareaList } from '../../../../store/actions/lookupActions'
import axios from 'axios';

const QualificationInput = ({uploadButton, getBase64, generateUrl, beforeUpload, onUpdate, value}) => {

  const [image, setImage] = useState()

  const [imageUrl, setImageUrl] = useState()
  const [title, setTitle] = useState("")

  const [isAnyFilled, setIsAnyFilled] = useState(false);

  useEffect(()=> {
    onUpdate({...value, title})
    setIsAnyFilled(title !== "" || imageUrl );
  }, [title])

  useEffect(()=> {
    onUpdate({...value, imageUrl})
    setIsAnyFilled(title !== "" || imageUrl );
  }, [imageUrl])

  useEffect(()=> {
    onUpdate({...value, image})
  }, [image])

  useEffect(() => {
    if (value?.image) {
        setImage(value.image)
    }
    setTitle(value?.title ? value.title : "")
  }, [value])

  const handleChangeImage = (info) => {
    setImageUrl(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setImage(imageUrl),
      // setloading(false)
    );
  };


  return (
    <div className="form-group d-flex flex-column align-items-center">
      
      <div>
        <Tooltip 
          title={image ?
            <a href={generateUrl(image)} target="_blank">
              <img src={image?.startsWith("data:application/pdf") || image?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : image} alt="preview" style={{ width: 200 }} />
            </a> :
            null} 
          placement="top"
        >
          <Upload
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChangeImage}
              required={isAnyFilled}
            >
              {image  ? 
                <img src={image?.startsWith("data:application/pdf") || image?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : image} alt="avatar" style={{ width: '90%' }} /> 
                : 
                uploadButton
              }
          </Upload>
        </Tooltip>
      </div>
      {isAnyFilled && !imageUrl && (
        <span style={{ color: 'red'}}>Image is required</span>
      )}

      <input type="text" 
          className='form-control form-control-sm'
          placeholder='Qualification name'
          required={isAnyFilled}
          onChange={(e) => setTitle(e.target.value)}
          value={title}
        />
  </div>
  )
}

const AchievementInput = ({onUpdate, value}) => {
  const [event, setEvent] = useState()
  const [category, setCategory] = useState()
  const [rank, setRank] = useState(1)
  const isSyncingFromValue = useRef(false);

  const [categoriesByEvent, setCategoriesByEvent] = useState();
  
  const { achievementEventList } = useSelector((state) => state.achievementEvent);

  const dispatch = useDispatch()

  useEffect(() => {
    isSyncingFromValue.current = true;

    if(value?.event) {setEvent(value.event)}
    if(value?.category) {setCategory(value?.category)}
    if(value?.rank) {setRank(value?.rank)}
  }, [value])

  useEffect(() => {
    dispatch(listAllEvents());
  }, [dispatch]);

  useEffect(()=> {
  if (isSyncingFromValue.current) {
    isSyncingFromValue.current = false; // reset for future updates
  }
    axios.get(`achievements/getCategoriesByEvent/${event}`).then(({data}) => {
       setCategoriesByEvent(data.data)
    })

    onUpdate({...value, event})
  }, [event])

  useEffect(()=> {
  if (isSyncingFromValue.current) {
    isSyncingFromValue.current = false; // reset for future updates
  }

    onUpdate({...value, category})
  }, [category])

  useEffect(()=> {
  if (isSyncingFromValue.current) {
    isSyncingFromValue.current = false; // reset for future updates
  }

    onUpdate({...value, rank})
  }, [rank])

  function handleEventChange(e){
    setEvent(e)
    axios.get(`achievements/getCategoriesByEvent/${e}`).then(({data}) => {
       setCategoriesByEvent(data.data)
    })
  }

  return (
    <div>
      <div>
        <label className='text-secondary'>Event</label>
        <Select
          onChange={handleEventChange}
          style={{ width: '100%' }}
          value={event}
          options={
              achievementEventList?.map((item) => ({
                value: item.id,
                label: item.name
              }))
            }
        >
        </Select>
      </div>

      {categoriesByEvent?.length > 0 && (
            <div className='mt-2'>
              <label className='text-secondary'>Category</label>
              <Select
                style={{ width: '100%' }}
                onChange={(e) => {setCategory(e)}}
                value={category}
                options={
                    categoriesByEvent?.map((item) => ({
                      value: item.id,
                      label: item.name
                    }))
                  }
              >
              </Select>
            </div>
        )
      }

      {category && (
        <div className='w-100 d-flex justify-content-center mt-2'>
          <label className='text-secondary mr-3'>Rank</label>
          <InputNumber
            min={1}
            value={rank}
            defaultValue={1}
            onChange={(value) => setRank(value)}
            formatter={(value) => `#${value}`}
            parser={(value) => value.replace('#', '')}
          />
        </div>
      )}
    </div>
  )
}
const AdviserCreate = () => {
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [office, setoffice] = useState('')
  const [phone, setphone] = useState('')
  const [gender, setgender] = useState('')
  const [joindate, setjoindate] = useState('')
  const [status, setstatus] = useState('')
  const [isnpwp, setisnpwp] = useState('')
  const [issalary, setissalary] = useState('')
  const [haired, sethaired] = useState('')
  const [nik, setNik] = useState('')

  const [isLoanSpesialis, setIsLoanSpesialis] = useState(false)
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [fax, setFax] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [officeArea, setOfficeArea] = useState('');
  const [password, setPassword] = useState('');

  const [nda, setNda] = useState();
  const [ndaFile, setNdaFile] = useState();

  const [mcquaig, setMcquaig] = useState();
  const [mcquaigFile, setMcquaigFile] = useState();

  const [pfindo, setPfindo] = useState();
  const [pfindoFile, setPfindoFile] = useState();

  const [ktp, setKtp] = useState();
  const [ktpFile, setKtpFile] = useState();

  const [achievements, setAchievements] = useState([{rank: null, event: null, category: null}]);

  const [qualification, setQualification] = useState([{ imageUrl: null, title: null, image: null }]);

  let dispatch = useDispatch()
  let history = useHistory()

  useEffect(() => {
    dispatch(officeAllList())
    dispatch(adviserAllList())
    dispatch(provinceList())
    dispatch(officeareaList())
  }, [dispatch])

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
    if (!userInfo.permission.includes("adviser-create")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const dataprovinceList = useSelector(state => state.provinceList)
  const { listsProvince } = dataprovinceList

  const handleChangeProvince = (value) => {
    setProvince(value)
    dispatch(citybyprovinceList(value))
  }

  const datacitybyprovince = useSelector(state => state.citybyprovinceList)
  const { listsCity } = datacitybyprovince

  const dataofficeareaList = useSelector(state => state.officeareaList)
  const { listsOfficeArea } = dataofficeareaList

  const dataofficeAllList = useSelector(state => state.officeAllList)
  const listsOffice = dataofficeAllList.listsOffice.map((item) => {return {value: item.value, label: item.label}})

  const dataadviserAllList = useSelector(state => state.adviserAllList)
  const listsAllAdviser = dataadviserAllList.listsAllAdviser.map((item) => {return {value: item.id, label: item.name}});

  const dataadviserSave = useSelector(state => state.adviserSave)
  const { validation } = dataadviserSave

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const created_by = userInfo.user.id
  
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(adviserSave(isLoanSpesialis, name, email, office, phone, gender, joindate, status, isnpwp, issalary, haired, created_by, history, nik, province, city, address, fax, whatsapp, officeArea, password, ndaFile, ktpFile, mcquaigFile, pfindoFile, achievements, qualification))
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function base64ToBlob(base64, type) {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];
    
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }
    
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type });
  }

  const handleChangeNDA = (info) => {
    setNdaFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setNda(imageUrl),
      // setloading(false)
    );
  };

  const handleChangeMcquaig = (info) => {
    setMcquaigFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setMcquaig(imageUrl),
      // setloading(false)
    );
  };

  const handleChangePfindo = (info) => {
    setPfindoFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setPfindo(imageUrl),
      // setloading(false)
    );
  };

  const handleChangeKtp = (info) => {
    setKtpFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setKtp(imageUrl),
      // setloading(false)
    );
  };

  const beforeUpload = (file) => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    
    if (!allowedTypes.includes(file.type)) {
      message.error('Only JPG, JPEG, PNG, and PDF files are allowed!');
      return Upload.LIST_IGNORE;
    }
  
    return true;
  };

  const generateUrl = (x) => {
    if(x?.startsWith("data:image")){
      return URL.createObjectURL(base64ToBlob(x,'image/png'))
    }
    if(x?.startsWith("data:application/pdf")){
      return URL.createObjectURL(base64ToBlob(x,'application/pdf'))
    }
    return x
  }

  const addAchievementInput = () => {
    setAchievements(prev => [...prev, { rank: null, event: null, category: null }]); // default empty object
  };

  const removeAchievementInput = (indexToRemove) => {
    setAchievements(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const updateAchievement = (index, newData) => {
    setAchievements(prev => {
      const updated = [...prev];
      updated[index] = newData;
      return updated;
    });
  };

  const addQualificationInput = () => {
    setQualification(prev => [...prev, { imageUrl: null, title: null, image: null }]); // default empty object
  };

  const removeQualificationInput = (indexToRemove) => {
    setQualification(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const updateQualification = (index, newData) => {
    setQualification(prev => {
      const updated = [...prev];
      updated[index] = newData;
      return updated;
    });
  };

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Create Adviser</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
              <div className="form-group">
                <label for="name">Loan Spesialis</label><br/>
                <Switch onChange={() => setIsLoanSpesialis(!isLoanSpesialis)} />
              </div>
            </div>
            
            <div className="x_content">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Name</label>
                      <input type="text" 
                        className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setname(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['name']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Email</label>
                      <input type="email" 
                        className={ validation.length !== 0 && validation['email'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setemail(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['email']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>
                <div>
                  <div className="form-group">
                    <label for="nik">NIK</label>
                    <input type="text" 
                      className='form-control'
                      required 
                      onChange={(e) => setNik(e.target.value)}
                    />
                  </div>
                </div>

                {
                  !isLoanSpesialis &&
                  <div className="form-group d-flex flex-column">
                    <label for="name">Office</label>
                    <Select
                      showSearch
                      placeholder="Select an office"
                      optionFilterProp="children"
                      onChange={(value) => setoffice(value)}
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      options={listsOffice}
                      value={office}
                    />
                    {
                          validation.length !== 0 
                          ?
                            <ul className="parsley-errors-list filled">
                              <li className="parsley-required">{validation['office']}</li>
                            </ul>
                          :
                            null
                        }
                  </div>

                }
                
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Phone</label>
                      <input type="text" 
                        className={ validation.length !== 0 && validation['phone'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setphone(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['phone']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Gender</label>
                      <select 
                        className={ validation.length !== 0 && validation['gender'] ? 'form-control parsley-error' : 'form-control' }
                        required
                        onChange={(e) => setgender(e.target.value)}
                      >
                        <option disabled selected value="">Select Gender</option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                      </select>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['gender']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Join Date</label>
                      <input type="date" 
                        className={ validation.length !== 0 && validation['join_date'] ? 'form-control parsley-error' : 'form-control' }
                        name="name" 
                        required 
                        onChange={(e) => setjoindate(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['join_date']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Status</label>
                      <select 
                        className={ validation.length !== 0 && validation['status'] ? 'form-control parsley-error' : 'form-control' }
                        required
                        onChange={(e) => setstatus(e.target.value)}
                      >
                        <option disabled selected value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                      </select>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['status']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="form-group d-flex flex-column">
                  <label for="name">Haired By</label>
                  <Select
                    showSearch
                    placeholder="Hired by"
                    optionFilterProp="children"
                    onChange={(value) => sethaired(value)}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={listsAllAdviser}
                    value={haired}
                  />
                  {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['haired']}</li>
                          </ul>
                        :
                          null
                      }
                </div>

                <div className="form-group d-flex flex-column">
                  <label>Training and Qualification</label>

                  <Collapse accordion style={{border: "none"}}>
                    {qualification.map((value, index) => (
                      <Collapse.Panel 
                        header={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{qualification[index].title || `Qualification ${index + 1}`}</span>
                            <button type='button' onClick={() => removeQualificationInput(index)} style={{ marginLeft: 'auto', color: 'darkblue', border: "none", borderRadius: "10px"}}><i class="fa fa-times"></i></button>
                          </div>
                        }
                        key={index}
                      >
                        <QualificationInput
                          uploadButton={uploadButton}
                          getBase64={getBase64}
                          generateUrl={generateUrl}
                          beforeUpload={beforeUpload}
                          onUpdate={(newValue) => updateQualification(index, newValue)}
                          value={value}
                        />
                      </Collapse.Panel>
                      ))
                    }
                  </Collapse>

                    <button 
                      style={{width: "20%", border: "none", alignSelf: "center", fontSize: "12px", marginTop: "10px"}}
                      type='button'
                      onClick={addQualificationInput}
                      >Add <PlusOutlined /></button>

                    {
                      validation.length !== 0 
                      ?
                        <ul className="parsley-errors-list filled">
                          <li className="parsley-required">{validation['qualification']}</li>
                        </ul>
                      :
                        null
                    }
                    
                </div>

                <div className="form-group d-flex flex-column">
                    <label>Achievements</label>
                    <Collapse accordion style={{border: "none"}}>
                      {achievements.map((value, index) => (
                          <Collapse.Panel 
                            header={
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span>{`Achievement ${index + 1}`}</span>
                                <button type='button' onClick={() => removeAchievementInput(index)} style={{ marginLeft: 'auto', color: 'darkblue', border: "none", borderRadius: "10px"}}><i class="fa fa-times"></i></button>
                              </div>
                            }
                            key={index}
                          >
                          <AchievementInput
                            onUpdate={(newValue) => updateAchievement(index, newValue)} 
                            value={value}
                          />
                        </Collapse.Panel>
                        ))
                      }
                    </Collapse>

                  <button 
                    style={{width: "20%", border: "none", alignSelf: "center", fontSize: "12px", marginTop: "10px"}}
                    type='button'
                    onClick={addAchievementInput}
                    >Add <PlusOutlined />
                  </button>
                </div>

                {
                  isLoanSpesialis &&
                  <>
                    <div className="row">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">Province</label>
                          <select 
                            className={ validation.length !== 0 && validation['province'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => handleChangeProvince(e.target.value)}
                          >
                            <option disabled selected value="">Select Province</option>
                            {
                              listsProvince.map((item, index) => {
                                return(
                                  <option value={item.id} key={index}>{item.name}</option>
                                )
                              })
                            }
                          </select>
                          {/* {
                                validation.length !== 0 
                                ?
                                  <ul className="parsley-errors-list filled">
                                    <li className="parsley-required">{validation['province']}</li>
                                  </ul>
                                :
                                  null
                              } */}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">City</label>
                          <select 
                            className={ validation.length !== 0 && validation['city'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => setCity(e.target.value)}
                          >
                            <option disabled selected value="">Select City</option>
                            {
                              listsCity.map((item, index) => {
                                return(
                                  <option value={item.id} key={index}>{item.name}</option>
                                )
                              })
                            }
                          </select>
                          {/* {
                                validation.length !== 0 
                                ?
                                  <ul className="parsley-errors-list filled">
                                    <li className="parsley-required">{validation['city']}</li>
                                  </ul>
                                :
                                  null
                              } */}
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label for="name">Address</label>
                      <textarea
                        className={ validation.length !== 0 && validation['address'] ? 'form-control parsley-error' : 'form-control' }
                        onChange={(e) => setAddress(e.target.value)}
                      ></textarea>
                      {
                            validation.length !== 0 
                            ?
                              <ul className="parsley-errors-list filled">
                                <li className="parsley-required">{validation['address']}</li>
                              </ul>
                            :
                              null
                          }
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">Fax</label>
                          <input type="text" 
                            className={ validation.length !== 0 && validation['fax'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => setFax(e.target.value)}
                          />
                          {
                            validation.length !== 0 
                            ?
                              <ul className="parsley-errors-list filled">
                                <li className="parsley-required">{validation['fax']}</li>
                              </ul>
                            :
                              null
                          }
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">Whatsapp</label>
                          <input type="text" 
                            className={ validation.length !== 0 && validation['whatsapp'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => setWhatsapp(e.target.value)}
                          />
                          {
                            validation.length !== 0 
                            ?
                              <ul className="parsley-errors-list filled">
                                <li className="parsley-required">{validation['whatsapp']}</li>
                              </ul>
                            :
                              null
                          }
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">Office Area</label>
                          <select 
                            className={ validation.length !== 0 && validation['office_area'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => setOfficeArea(e.target.value)}
                          >
                            <option disabled selected value="">Select Office Area</option>
                            {
                              listsOfficeArea.map((item, index) => {
                                return(
                                  <option value={item.id} key={index}>{item.name}</option>
                                )
                              })
                            }
                              </select>
                          {
                            validation.length !== 0 
                            ?
                              <ul className="parsley-errors-list filled">
                                <li className="parsley-required">{validation['office_area']}</li>
                              </ul>
                            :
                              null
                          }
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <label for="name">Password</label>
                          <input type="text" 
                            className={ validation.length !== 0 && validation['password'] ? 'form-control parsley-error' : 'form-control' }
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          {
                            validation.length !== 0 
                            ?
                              <ul className="parsley-errors-list filled">
                                <li className="parsley-required">{validation['password']}</li>
                              </ul>
                            :
                              null
                          }
                        </div>
                      </div>
                    </div>
                  </>
                }

                <div className="row">
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <div className="form-group">
                      <label for="name">NPWP</label><br/>
                      <Switch defaultChecked onChange={(e) => setisnpwp(e)} />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['npwp']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <div className="form-group">
                      <label for="name">Salary</label><br/>
                      <Switch defaultChecked onChange={(e) => setissalary(e)} />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['salary']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>NDA</label>
                    <Tooltip 
                      title={nda !== undefined ?
                        <a href={generateUrl(nda)} target="_blank">
                          <img src={nda?.startsWith("data:application/pdf") || nda?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : nda} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null} 
                      placement="top"
                    >
                      <Upload

                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={handleChangeNDA}
                          >
                            {nda !== undefined ? 
                              <img src={nda?.startsWith("data:application/pdf") || nda?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : nda} alt="avatar" style={{ width: '90%' }} /> 
                              : 
                              uploadButton
                            }
                      </Upload>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['nda']}</li>
                          </ul>
                        :
                          null
                      }
                    </Tooltip>
                  </div>

                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>Mcquaig Test</label>
                    <Tooltip 
                      title={mcquaig !== undefined ?
                        <a href={generateUrl(mcquaig)} target="_blank">
                          <img src={mcquaig?.startsWith("data:application/pdf") || mcquaig?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : mcquaig} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null} 
                      placement="top"
                    >
                      <Upload
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          onChange={handleChangeMcquaig}
                          beforeUpload={beforeUpload}
                        >
                          {mcquaig !== undefined ? <img src={mcquaig?.startsWith("data:application/pdf") || mcquaig?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : mcquaig} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                        {
                          validation.length !== 0 
                          ?
                            <ul className="parsley-errors-list filled">
                              <li className="parsley-required">{validation['mcquaig']}</li>
                            </ul>
                          :
                            null
                        }
                      </Tooltip>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>Pefindo Score</label>
                    <Tooltip 
                      title={pfindo !== undefined ?
                        <a href={generateUrl(pfindo)} target="_blank">
                          <img src={pfindo?.startsWith("data:application/pdf") || pfindo?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : pfindo} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null} 
                      placement="top"
                    >
                      <Upload
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            onChange={handleChangePfindo}
                            beforeUpload={beforeUpload}
                          >
                            {pfindo !== undefined ? <img src={pfindo?.startsWith("data:application/pdf") || pfindo?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : pfindo} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['pfindo']}</li>
                          </ul>
                        :
                          null
                      }
                    </Tooltip>
                  </div>

                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>KTP</label>
                    <Tooltip 
                      title={ktp !== undefined ?
                        <a href={generateUrl(ktp)} target="_blank">
                          <img src={ktp?.startsWith("data:application/pdf") || ktp?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : ktp} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null} 
                      placement="top"
                    >
                      <Upload
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          onChange={handleChangeKtp}
                          beforeUpload={beforeUpload}
                        >
                          {ktp !== undefined ? <img src={ktp?.startsWith("data:application/pdf") || ktp?.endsWith(".pdf") ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : ktp} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                        {
                          validation.length !== 0 
                          ?
                            <ul className="parsley-errors-list filled">
                              <li className="parsley-required">{validation['ktp']}</li>
                            </ul>
                          :
                            null
                        }
                      </Tooltip>
                  </div>
                </div>

                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdviserCreate
